import type { MediaItem, WebhookConfig } from './types';

// BACKEND INTEGRATION: Replace mockSeries with fetch to Sonarr /api/v3/series
export const mockSeries: MediaItem[] = [
{
  id: 'series-001',
  title: 'The Last of Us',
  year: 2023,
  status: 'Continuing',
  genres: ['Drama', 'Sci-Fi', 'Thriller'],
  rating: 8.8,
  posterUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_144d7a9d6-1773503657172.png",
  mediaType: 'series',
  network: 'HBO',
  seasonCount: 2,
  episodeCount: 19,
  qualityProfile: 'HD-1080p',
  monitored: true,
  overview: 'A smuggler must escort a teenager across a post-apocalyptic United States.'
},
{
  id: 'series-002',
  title: 'Severance',
  year: 2022,
  status: 'Continuing',
  genres: ['Drama', 'Sci-Fi', 'Thriller'],
  rating: 8.7,
  posterUrl: 'https://image.tmdb.org/t/p/w300/lgkgICxmdIapOrGn35IeSl7e1Oa.jpg',
  mediaType: 'series',
  network: 'Apple TV+',
  seasonCount: 2,
  episodeCount: 19,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-003',
  title: 'The Bear',
  year: 2022,
  status: 'Continuing',
  genres: ['Drama', 'Comedy'],
  rating: 8.6,
  posterUrl: 'https://image.tmdb.org/t/p/w300/sHFlbKS3WLqMnp9t2ghADIJFnuQ.jpg',
  mediaType: 'series',
  network: 'FX',
  seasonCount: 3,
  episodeCount: 28,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-004',
  title: 'Succession',
  year: 2018,
  status: 'Ended',
  genres: ['Drama', 'Comedy'],
  rating: 8.9,
  posterUrl: 'https://image.tmdb.org/t/p/w300/7HW47XbkNQ5fiwQFYGWdw9gs144.jpg',
  mediaType: 'series',
  network: 'HBO',
  seasonCount: 4,
  episodeCount: 39,
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'series-005',
  title: 'House of the Dragon',
  year: 2022,
  status: 'Continuing',
  genres: ['Drama', 'Action', 'Adventure'],
  rating: 8.4,
  posterUrl: 'https://image.tmdb.org/t/p/w300/t9XkeegN9KMnmCcBxkCMDSKQpQS.jpg',
  mediaType: 'series',
  network: 'HBO',
  seasonCount: 2,
  episodeCount: 18,
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'series-006',
  title: 'Andor',
  year: 2022,
  status: 'Continuing',
  genres: ['Sci-Fi', 'Action', 'Drama'],
  rating: 8.4,
  posterUrl: 'https://image.tmdb.org/t/p/w300/59SVNwLfoMnZPPB6ukW6dlPxAdI.jpg',
  mediaType: 'series',
  network: 'Disney+',
  seasonCount: 2,
  episodeCount: 24,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-007',
  title: 'The White Lotus',
  year: 2021,
  status: 'Continuing',
  genres: ['Drama', 'Comedy', 'Thriller'],
  rating: 8.1,
  posterUrl: 'https://image.tmdb.org/t/p/w300/kVm7dJyeEPFJSCpfWMRBGqfMOyO.jpg',
  mediaType: 'series',
  network: 'HBO',
  seasonCount: 3,
  episodeCount: 24,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-008',
  title: 'Breaking Bad',
  year: 2008,
  status: 'Ended',
  genres: ['Crime', 'Drama', 'Thriller'],
  rating: 9.5,
  posterUrl: 'https://image.tmdb.org/t/p/w300/ggFHVNu6YYI5L9pCfOacjizRGt.jpg',
  mediaType: 'series',
  network: 'AMC',
  seasonCount: 5,
  episodeCount: 62,
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'series-009',
  title: 'Fallout',
  year: 2024,
  status: 'Continuing',
  genres: ['Sci-Fi', 'Action', 'Adventure'],
  rating: 8.5,
  posterUrl: 'https://image.tmdb.org/t/p/w300/AnsSKR6CgRQiSCJHxJa8HrFpM1.jpg',
  mediaType: 'series',
  network: 'Prime Video',
  seasonCount: 1,
  episodeCount: 8,
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'series-010',
  title: 'Shogun',
  year: 2024,
  status: 'Ended',
  genres: ['Drama', 'Action', 'Adventure'],
  rating: 8.8,
  posterUrl: 'https://image.tmdb.org/t/p/w300/7O4iVfOMQmdCSxhOg1WnzG1AgYT.jpg',
  mediaType: 'series',
  network: 'FX',
  seasonCount: 1,
  episodeCount: 10,
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'series-011',
  title: 'Dark Matter',
  year: 2024,
  status: 'Continuing',
  genres: ['Sci-Fi', 'Thriller', 'Drama'],
  rating: 7.8,
  posterUrl: 'https://image.tmdb.org/t/p/w300/frwl2zBNAl5ZbFDJGoJv0CSd90X.jpg',
  mediaType: 'series',
  network: 'Apple TV+',
  seasonCount: 1,
  episodeCount: 9,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-012',
  title: 'The Penguin',
  year: 2024,
  status: 'Ended',
  genres: ['Crime', 'Drama', 'Action'],
  rating: 8.5,
  posterUrl: 'https://image.tmdb.org/t/p/w300/3VxUj8RJMnFYnPEJpzFbpvPBBLx.jpg',
  mediaType: 'series',
  network: 'HBO',
  seasonCount: 1,
  episodeCount: 8,
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'series-013',
  title: 'Silo',
  year: 2023,
  status: 'Continuing',
  genres: ['Sci-Fi', 'Drama', 'Thriller'],
  rating: 8.0,
  posterUrl: 'https://image.tmdb.org/t/p/w300/xy67KqBJgqgMNMFJpbEoUhxnHIU.jpg',
  mediaType: 'series',
  network: 'Apple TV+',
  seasonCount: 2,
  episodeCount: 20,
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'series-014',
  title: 'Slow Horses',
  year: 2022,
  status: 'Continuing',
  genres: ['Crime', 'Drama', 'Thriller'],
  rating: 8.0,
  posterUrl: 'https://image.tmdb.org/t/p/w300/4pTSXEMHfpuaOZFGvyqzBPNVVCf.jpg',
  mediaType: 'series',
  network: 'Apple TV+',
  seasonCount: 4,
  episodeCount: 24,
  qualityProfile: 'HD-1080p',
  monitored: true
}];


// BACKEND INTEGRATION: Replace mockMovies with fetch to Radarr /api/v3/movie
export const mockMovies: MediaItem[] = [
{
  id: 'movie-001',
  title: 'Dune: Part Two',
  year: 2024,
  status: 'Available',
  genres: ['Sci-Fi', 'Adventure', 'Action'],
  rating: 8.5,
  posterUrl: 'https://image.tmdb.org/t/p/w300/8b8R8l88Qje9dn9OE8PY05Nxl1X.jpg',
  mediaType: 'movie',
  studio: 'Legendary Pictures',
  runtime: 166,
  certification: 'PG-13',
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'movie-002',
  title: 'Oppenheimer',
  year: 2023,
  status: 'Available',
  genres: ['Drama', 'Thriller'],
  rating: 8.3,
  posterUrl: 'https://image.tmdb.org/t/p/w300/8Gxv8gSFCU0XGDykEGv7zR1n2ua.jpg',
  mediaType: 'movie',
  studio: 'Universal Pictures',
  runtime: 180,
  certification: 'R',
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'movie-003',
  title: 'Poor Things',
  year: 2023,
  status: 'Available',
  genres: ['Comedy', 'Drama', 'Sci-Fi'],
  rating: 8.0,
  posterUrl: 'https://image.tmdb.org/t/p/w300/kCGlIMHnOm8JPXIf6GFMS4tNQ1.jpg',
  mediaType: 'movie',
  studio: 'Film4',
  runtime: 141,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-004',
  title: 'Alien: Romulus',
  year: 2024,
  status: 'Available',
  genres: ['Horror', 'Sci-Fi', 'Action'],
  rating: 7.3,
  posterUrl: 'https://image.tmdb.org/t/p/w300/b33nnKl1GSFbao4l3fZDDqsMx0F.jpg',
  mediaType: 'movie',
  studio: '20th Century Studios',
  runtime: 119,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-005',
  title: 'Furiosa: A Mad Max Saga',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Adventure', 'Sci-Fi'],
  rating: 7.8,
  posterUrl: 'https://image.tmdb.org/t/p/w300/iADOJ8Zymht2JPMoy3R7xceZprc.jpg',
  mediaType: 'movie',
  studio: 'Kennedy Miller Mitchell',
  runtime: 148,
  certification: 'R',
  qualityProfile: 'Ultra-HD',
  monitored: false
},
{
  id: 'movie-006',
  title: 'The Zone of Interest',
  year: 2023,
  status: 'Available',
  genres: ['Drama', 'Horror'],
  rating: 7.4,
  posterUrl: 'https://image.tmdb.org/t/p/w300/hUu9zyZmKuTosVMgQSwjNFmqmVP.jpg',
  mediaType: 'movie',
  studio: 'A24',
  runtime: 105,
  certification: 'PG-13',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-007',
  title: 'Longlegs',
  year: 2024,
  status: 'Available',
  genres: ['Horror', 'Thriller', 'Crime'],
  rating: 6.3,
  posterUrl: 'https://image.tmdb.org/t/p/w300/kKgQzkUCnQmeTPkyIwHly2t6ZFI.jpg',
  mediaType: 'movie',
  studio: 'Neon',
  runtime: 101,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'movie-008',
  title: 'A Quiet Place: Day One',
  year: 2024,
  status: 'Available',
  genres: ['Horror', 'Sci-Fi', 'Thriller'],
  rating: 7.0,
  posterUrl: 'https://image.tmdb.org/t/p/w300/yrpPYKijwdMHyTGIOd1iK1h0Xno.jpg',
  mediaType: 'movie',
  studio: 'Paramount Pictures',
  runtime: 99,
  certification: 'PG-13',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-009',
  title: 'Civil War',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Drama', 'Thriller'],
  rating: 7.2,
  posterUrl: 'https://image.tmdb.org/t/p/w300/sh7Rg8Er3tFcN9BpKIPOMvALgZd.jpg',
  mediaType: 'movie',
  studio: 'A24',
  runtime: 109,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-010',
  title: 'Monkey Man',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Crime', 'Thriller'],
  rating: 7.0,
  posterUrl: 'https://image.tmdb.org/t/p/w300/a8w0IA6MK3TS4hMNRTwYcnJtl0N.jpg',
  mediaType: 'movie',
  studio: 'Bron Creative',
  runtime: 122,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: false
},
{
  id: 'movie-011',
  title: 'Twisters',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Adventure', 'Drama'],
  rating: 7.2,
  posterUrl: 'https://image.tmdb.org/t/p/w300/pjnD08FlMAIXsfOLKQbvmO0f0MD.jpg',
  mediaType: 'movie',
  studio: 'Universal Pictures',
  runtime: 122,
  certification: 'PG-13',
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'movie-012',
  title: 'Conclave',
  year: 2024,
  status: 'Available',
  genres: ['Drama', 'Thriller'],
  rating: 7.4,
  posterUrl: 'https://image.tmdb.org/t/p/w300/m5ZADkFTdFnFMJRdJoq3mCn7Jqg.jpg',
  mediaType: 'movie',
  studio: 'FilmNation Entertainment',
  runtime: 120,
  certification: 'PG',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-013',
  title: 'Nosferatu',
  year: 2024,
  status: 'Available',
  genres: ['Horror', 'Drama'],
  rating: 7.4,
  posterUrl: 'https://image.tmdb.org/t/p/w300/5qGIxdEO841C0tdY8vOdLoRVrr0.jpg',
  mediaType: 'movie',
  studio: 'Focus Features',
  runtime: 132,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-014',
  title: 'Gladiator II',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Adventure', 'Drama'],
  rating: 7.1,
  posterUrl: 'https://image.tmdb.org/t/p/w300/2cxhvwyEwRlysAmRH4iodkvo0z5.jpg',
  mediaType: 'movie',
  studio: 'Paramount Pictures',
  runtime: 148,
  certification: 'R',
  qualityProfile: 'Ultra-HD',
  monitored: false
},
{
  id: 'movie-015',
  title: 'The Substance',
  year: 2024,
  status: 'Available',
  genres: ['Horror', 'Drama', 'Sci-Fi'],
  rating: 7.3,
  posterUrl: 'https://image.tmdb.org/t/p/w300/lqoMzCcZYEFK729d6qzt349fB4o.jpg',
  mediaType: 'movie',
  studio: 'Working Title Films',
  runtime: 140,
  certification: 'R',
  qualityProfile: 'HD-1080p',
  monitored: true
},
{
  id: 'movie-016',
  title: 'Deadpool & Wolverine',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Comedy', 'Sci-Fi'],
  rating: 7.8,
  posterUrl: 'https://image.tmdb.org/t/p/w300/8cdWjvZQUExUUTzyp4t6EDMubfO.jpg',
  mediaType: 'movie',
  studio: 'Marvel Studios',
  runtime: 127,
  certification: 'R',
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'movie-017',
  title: 'Wicked',
  year: 2024,
  status: 'In Cinemas',
  genres: ['Drama', 'Adventure'],
  rating: 7.6,
  posterUrl: 'https://image.tmdb.org/t/p/w300/xDGbZ0JJ3mYaGKy4Nzd9Kph6M9L.jpg',
  mediaType: 'movie',
  studio: 'Universal Pictures',
  runtime: 160,
  certification: 'PG',
  qualityProfile: 'Ultra-HD',
  monitored: true
},
{
  id: 'movie-018',
  title: 'Kingdom of the Planet of the Apes',
  year: 2024,
  status: 'Available',
  genres: ['Action', 'Adventure', 'Sci-Fi'],
  rating: 7.0,
  posterUrl: "https://images.unsplash.com/photo-1641400731147-5ff3652bb4ba",
  mediaType: 'movie',
  studio: '20th Century Studios',
  runtime: 145,
  certification: 'PG-13',
  qualityProfile: 'HD-1080p',
  monitored: false
}];


// BACKEND INTEGRATION: Replace mockWebhooks with data from localStorage or config API
export const mockWebhooks: WebhookConfig[] = [
{
  id: 'webhook-001',
  name: 'Jellyfin Refresh',
  url: 'http://localhost:8096/Library/Refresh',
  method: 'POST',
  authHeader: 'Bearer my-jellyfin-token',
  createdAt: '2026-06-15T10:22:00Z'
},
{
  id: 'webhook-002',
  name: 'n8n Automation',
  url: 'https://n8n.homelab.local/webhook/media-dispatch',
  method: 'POST',
  createdAt: '2026-07-01T08:45:00Z'
}];